import {lazy} from '@aboutyou/lazy-imports';

export const ReleaseBanner = lazy(() =>
  import('./ReleaseBanner.eager').then(mod => ({
    default: mod.ReleaseBanner,
  })),
);
